// extracted by mini-css-extract-plugin
export default {"container":"accordion_container__UGGN1","heading":"accordion_heading__MZpZE","content":"accordion_content__wLtqL"};